module.exports = __webpack_public_path__ + "static/media/BoxImage_Done.df9de8a7.png";